module.exports = __webpack_public_path__ + "static/kran01_1920-5bf4bd99767fa06d0be239f8ee58eec0.jpg";